

class Regex{
  email = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/

  number = /^[0-9]+$/
}

export default new Regex();